import React from "react";
import styled from "styled-components";

type TypeProps = {
  colors?: any;
  badgeSelect: boolean;
  selectedSection: (dt: any) => void;
  dataSections: any;
};

export default function FilterByCategory(props: TypeProps) {
  const { colors } = props;
  return (
    <>
      <h5>Filtra por categorías</h5>
      {colors ? (
        <ListBadgesCustom colors={colors}>
          <span
            className={`badge ${
              props.badgeSelect ? "bg-light" : colors ? "bg-custom" : "bg-info"
            } cursor-pointer`}
            onClick={() => props.selectedSection(null)}
          >
            Todos
          </span>
          {props.dataSections.map((section: any, index: any) => (
            <div key={index}>
              <span
                className={`badge ${
                  props.badgeSelect === section.id ? "bg-custom" : "bg-light"
                } cursor-pointer`}
                onClick={() => props.selectedSection(section)}
              >
                {section.name}
              </span>
            </div>
          ))}
        </ListBadgesCustom>
      ) : (
        <ListBadges>
          <span
            className={`badge ${
              props.badgeSelect ? "bg-light" : "bg-info"
            } cursor-pointer`}
            onClick={() => props.selectedSection(null)}
          >
            Todos
          </span>
          {props.dataSections.map((section: any, index: any) => (
            <div key={index}>
              <span
                className={`badge ${
                  props.badgeSelect === section.id ? "bg-info" : "bg-light"
                } cursor-pointer`}
                onClick={() => props.selectedSection(section)}
              >
                {section.name}
              </span>
            </div>
          ))}
        </ListBadges>
      )}
    </>
  );
}

interface Colors {
  colors?: any;
}

const ListBadges = styled.div`
  position: relative;
  width: 100%;
  white-space: nowrap;
  overflow-y: hidden;
  overflow-x: scroll;
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 0;
    height: 0;
  }
  span {
    font-weight: normal;
  }
  div {
    padding: 0em 1em;
    padding-top: 1em;
    padding-bottom: 3em;
    display: inline-block;
  }
`;
const ListBadgesCustom = styled.div<Colors>`
  position: relative;
  width: 100%;
  white-space: nowrap;
  overflow-y: hidden;
  overflow-x: scroll;
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 0;
    height: 0;
  }
  .bg-custom {
    background-color: ${(props) => props.colors.colors2};
  }
  span {
    font-weight: normal;
  }
  div {
    padding: 0em 1em;
    padding-top: 1em;
    padding-bottom: 3em;
    display: inline-block;
  }
`;
